import React, {Component} from 'react'
import { withRouter } from "react-router-dom"
import FormColumn from '../../../Templates/FormColumn'
class FileManager extends Component {
    render(){
       return <div id="file-manager-container" className="overflow shadow">
                    <h3 id="file-manager-header">Decimation Queue</h3>
                    <div id="columns-container" className="flex-centered">
                        <FormColumn title={"File Name"} content={this.props.names} numColumns={2}/>
                        <FormColumn title={"Model Status"} fragments={true} content={this.props.progress} numColumns={2}/>
                    </div>
                </div>
    }
}

export default withRouter(FileManager)

